/**
 * Adapter for sending some ILogrObject events to FB using FB SDK
 *
 * @param appId
 * @param version
 *
 * @see https://developers.facebook.com/docs/reference/javascript/FB.AppEvents.LogEvent
 */
function FBAppEventsLogr(appId, version) {

    var SDK = 'https://connect.facebook.net/en_US/sdk.js';

    /* global FB */
    var logEvent;

    getScript(SDK, function (err) {
        if (err) {
            Logger.error('FBSdk initialize error: ' + err);
            return;
        }

        FB.init({
            appId: appId,
            version: version || 'v9.0'
        });

        logEvent = function (name, valueToSum, params) {
            var fbName = name in FB.AppEvents.EventNames
                ? FB.AppEvents.EventNames[name]
                : name;
            var fbParams = null;
            if (params) {
                fbParams = {};
                for (var paramName in params) {
                    if (!params.hasOwnProperty(paramName)) {
                        continue;
                    }
                    if (paramName in FB.AppEvents.ParameterNames) {
                        fbParams[FB.AppEvents.ParameterNames[paramName]] = params[paramName];
                    } else {
                        fbParams[paramName] = params[paramName];
                    }
                }
            }
            FB.AppEvents.logEvent(fbName, valueToSum, fbParams);
        }
    });

    return function (params) {
        if (!logEvent) {
            return;
        }

        var name = params['name'];
        var narg = params['narg'];
        var sarg = params['sarg'];

        if (name === 'LevelUp') {
            logEvent('ACHIEVED_LEVEL', null, {
                LEVEL: narg['lvl']
            })
        } else if (name === 'TutorialComplete') {
            logEvent('COMPLETED_TUTORIAL');
        } else if (name === 'PremiumSpent') {
            logEvent('SPENT_CREDITS', narg['price'], {
                CONTENT_TYPE: sarg['type'],
                CONTENT_ID: sarg['name']
            });
        } else if (name === 'CharacterCreationComplete') {
            logEvent('COMPLETED_REGISTRATION')
        } else if (name === 'ArenaTutorialComplete') {
            logEvent('ArenaTutorialComplete')
        } else if (name === 'BuyForRealMoney') {
            if (sarg['isFirst']) {
                logEvent('FirstPurchase', null, {
                    offerId: sarg['offerId']
                });
            }
        }
    }

}